import React, { type ReactElement } from "react";
import { useDatePickerStateContext } from "@rehookify/datepicker";
import format from "date-fns/format";

import { SupButton } from "../../../../components/UI/Button";
import { SupText } from "../../../../components/UI/Text";

interface HeaderProps {
  prevButton?: ReactElement;
  nextButton?: ReactElement;
  onToggle?: (pickerType: "month" | "year" | "time") => void;
}

export function Header({ prevButton, nextButton, onToggle }: HeaderProps) {
  const { offsetDate } = useDatePickerStateContext();

  return (
    <div className="sup-calendar-head flex justify-center items-center py-1.5 px-2">
      <span className="inline-flex mr-auto">{prevButton}</span>

      <div className="flex gap-1">
        <SupText as="span" variant="subtitle1" className="leading-10 font-bold">
          {format(offsetDate, "dd")}
        </SupText>

        <SupButton
          variant="outlined"
          className="[&>span]:font-bold"
          onClick={() => {
            onToggle?.("month");
          }}
        >
          {format(offsetDate, "MMMM")}
        </SupButton>

        <SupButton
          variant="outlined"
          className="[&>span]:font-bold"
          onClick={() => {
            onToggle?.("year");
          }}
        >
          {format(offsetDate, "yyyy")}
        </SupButton>
      </div>

      <span className="inline-flex ml-auto">{nextButton}</span>
    </div>
  );
}
